/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type utilizationListComponent_QueryVariables = {
    shareKey?: string | null | undefined;
    dateCriteria?: string | null | undefined;
    componentId?: string | null | undefined;
    personIds?: Array<string | null> | null | undefined;
    teamIds?: Array<string | null> | null | undefined;
    roleIds?: Array<string | null> | null | undefined;
    labelIds?: Array<string | null> | null | undefined;
    projectStatusesBackend?: Array<string | null> | null | undefined;
};
export type utilizationListComponent_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"utilizationListComponent_viewer">;
    } | null;
};
export type utilizationListComponent_Query = {
    readonly response: utilizationListComponent_QueryResponse;
    readonly variables: utilizationListComponent_QueryVariables;
};



/*
query utilizationListComponent_Query(
  $shareKey: String
  $dateCriteria: String
  $componentId: ID
  $personIds: [ID]
  $teamIds: [ID]
  $roleIds: [ID]
  $labelIds: [ID]
  $projectStatusesBackend: [ID]
) {
  viewer {
    actualPersonId
    component(name: "insight_utilization_list")
    ...utilizationListComponent_viewer_1IcmZU
    id
  }
}

fragment utilizationListComponent_viewer_1IcmZU on Viewer {
  insightComponentsData(shareKey: $shareKey) {
    utilizationList(dateCriteria: $dateCriteria, personIds: $personIds, componentId: $componentId, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds, projectStatusesBackend: $projectStatusesBackend) {
      id
      availableMinutesTotal
      scheduledMinutesTotal
      scheduledProjectTimeMinutes
      scheduledNonProjectTimeMinutes
      reportedTotal
      assignedTasksForecastTotal
      overTimeMinutesTotal
      billableMinutesRegisteredTotal
      billableMinutesPlannedTotal
      utilizationListData {
        id
        name
        profilePictureId
        profilePictureDefaultId
        roleName
        availableMinutes
        scheduledMinutes
        scheduledNonProjectTimeMinutes
        scheduledProjectTimeMinutes
        reported
        billableMinutesRegistered
        billableMinutesPlanned
        cardMinutesPlanned
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shareKey",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateCriteria",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "componentId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roleIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labelIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectStatusesBackend",
    "type": "[ID]"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "insight_utilization_list"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"insight_utilization_list\")"
},
v3 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v4 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v5 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v6 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v7 = {
  "kind": "Variable",
  "name": "projectStatusesBackend",
  "variableName": "projectStatusesBackend"
},
v8 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v9 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v10 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledProjectTimeMinutes",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledNonProjectTimeMinutes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "utilizationListComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "utilizationListComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "utilizationListComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              (v9/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "UtilizationList",
                "kind": "LinkedField",
                "name": "utilizationList",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableMinutesTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scheduledMinutesTotal",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reportedTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedTasksForecastTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overTimeMinutesTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableMinutesRegisteredTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableMinutesPlannedTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UtilizationListPerson",
                    "kind": "LinkedField",
                    "name": "utilizationListData",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePictureDefaultId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roleName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "availableMinutes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledMinutes",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reported",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableMinutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billableMinutesPlanned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cardMinutesPlanned",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "utilizationListComponent_Query",
    "operationKind": "query",
    "text": "query utilizationListComponent_Query(\n  $shareKey: String\n  $dateCriteria: String\n  $componentId: ID\n  $personIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n  $projectStatusesBackend: [ID]\n) {\n  viewer {\n    actualPersonId\n    component(name: \"insight_utilization_list\")\n    ...utilizationListComponent_viewer_1IcmZU\n    id\n  }\n}\n\nfragment utilizationListComponent_viewer_1IcmZU on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    utilizationList(dateCriteria: $dateCriteria, personIds: $personIds, componentId: $componentId, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds, projectStatusesBackend: $projectStatusesBackend) {\n      id\n      availableMinutesTotal\n      scheduledMinutesTotal\n      scheduledProjectTimeMinutes\n      scheduledNonProjectTimeMinutes\n      reportedTotal\n      assignedTasksForecastTotal\n      overTimeMinutesTotal\n      billableMinutesRegisteredTotal\n      billableMinutesPlannedTotal\n      utilizationListData {\n        id\n        name\n        profilePictureId\n        profilePictureDefaultId\n        roleName\n        availableMinutes\n        scheduledMinutes\n        scheduledNonProjectTimeMinutes\n        scheduledProjectTimeMinutes\n        reported\n        billableMinutesRegistered\n        billableMinutesPlanned\n        cardMinutesPlanned\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'eeb6c55023c02a56ad9a506f4b1621d4';
export default node;
